<template>
  <div class="creatives" :class="{ white: !isDark, dark: isDark }">
    <header :class="{ blur: reviewShow }">
      <a class="logo"></a>
      <div class="tab-list">
        <div
          :class="{ active: index === tabIndex }"
          class="tab-item"
          v-for="(item, index) in tabList"
          :key="index"
          @click="tabChangeHandler(item, index, $event)"
        >
          <span>{{ item.value }}</span>
        </div>
        <div class="tab-bottom-line-aisle">
          <div class="tab-bottom-line" ref="line"></div>
        </div>
      </div>

      <div class="user-info">
        <a @click="backAdam" class="back">
          <img src="../assets/images/back-adam-icon.png" alt />
          <p>返回ADAM</p>
        </a>
        <el-popover placement="bottom" width="120" trigger="click">
          <div class="info" slot="reference">
            <div class="avatar">
              <img src alt />
            </div>
            <p class="name">{{ userInfo.name }}</p>
            <i href class="more"></i>
          </div>
          <div class="logout">
            <!-- <div class="logout-item" @click.stop="toFeatures">功能介绍</div> -->
            <div class="logout-item" @click.stop="logoutConfirm">退出登录</div>
          </div>
        </el-popover>
      </div>
    </header>
    <!-- <div class="toggle-thumnb" :class="{ blur: reviewShow }" v-show="tabIndex === 0">
      <i class="icon dark" @click="isDark = true"></i>
      <i class="icon white" @click="isDark = false"></i>
    </div>-->

    <div
      class="to-top"
      v-show="currentTab.index !== 2"
      :class="{ blur: reviewShow }"
      @click="toTop"
    ></div>

    <router-view
      @changeReview="changeReview"
      :isDark="isDark"
      :count="refreshCount"
      :class="{ blur: reviewShow }"
    ></router-view>

    <!-- 广告内容推荐 -->
    <!-- <recommend  v-show="currentTab.index === 0"></recommend> -->
    <!-- 外部素材库 -->
    <!-- <third-party-database v-show="currentTab.index === 1" /> -->
    <!-- 素材库 -->
    <!-- <material-library v-if="currentTab.index === 2" /> -->
  </div>
</template>

<script>
import materialLibrary from "./materialLibrary/index";
import thirdPartyDatabase from "./thirdPartyDatabase/Index";
import recommend from "./recommend/Index";

export default {
  components: { materialLibrary, thirdPartyDatabase, recommend },
  data() {
    return {
      reviewShow: false,
      currentTab: { index: 0 },
      tabList: [
        { active: false, value: "广告内容推荐", index: 0, url: "/index" },
        {
          active: false,
          value: "外部素材推荐",
          index: 1,
          url: "/third-party-material"
        },
        { active: false, value: "素材库", index: 2, url: "/material-library" }
      ],
      // 便于开发临时设置 hasayake set
      tabIndex: 0,
      isDark: false,
      scrollObj: "body",
      userInfo: {},
      refreshCount: 0
    };
  },
  created() {
    this.redirectTabCurrent();

    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    let menuList = JSON.parse(localStorage.getItem("menuList"));
    let url = this.$router.currentRoute.fullPath;

    for (let i = 0; i < this.tabList.length; i++) {
      if (url === this.tabList[i].url) {
        this.currentTab = this.tabList[i];
        this.tabIndex = i;
      }
      menuList.map(item => {
        let count = item.children.filter(it => it.url === this.tabList[i].url)
          .length;
        if (count === 0) {
          this.tabList.splice(i, 1);
          i--;
        }
      });
    }



  },
  watch: {
    isDark(val) {
      document.body.classList[val ? "add" : "remove"]("dark");
    },
    $route(route) {
      this.redirectTabCurrent();
    }
  },
  mounted() {
    document.querySelector(".creatives").style.minHeight =
      document.documentElement.clientHeight + "px";

    const el = document.querySelector('.tab-list .active')
    this.tabSwitchTransitionHandler(el)
  },
  methods: {
    changeReview(payload) {
      this.reviewShow = payload;
    },
    redirectTabCurrent() {
      // 非点击tab情况下重置tab活动栏，如浏览器前进后退,或直接跳素材库
      let index = this.tabList.findIndex(item => {
        return item.url === this.$route.path;
      });
      // 处理路由为‘/’的情况
      index === -1 && (index = 0);
      this.tabIndex = index;

      this.$nextTick(() => {
        const el = document.querySelector('.tab-list .active')
        this.tabSwitchTransitionHandler(el)
      })
    },
    // tabchange
    tabChangeHandler(item, index, ev) {
      const e = ev || window.event;
      this.currentTab = item;
      this.tabIndex = index;
      this.$router.push(item.url);

      this.tabSwitchTransitionHandler(e.currentTarget);
    },
    // tab 切换动画
    tabSwitchTransitionHandler(target) {
      const left = target.offsetLeft;
      const width = +getComputedStyle(target, null)
        .getPropertyValue("width")
        .replace("px", "");

      this.$refs.line.style.cssText = `
        width: ${width}px;
        transform: translateX(${left + 24}px);
      `;

    },
    backAdam() {
      window.location.href = `https://www.adamroi.com/?token=${localStorage.token}`;
    },
    logoutConfirm() {
      localStorage.menuList = "[]";
      localStorage.token = "";
      this.$router.push("/login");
    },
    toTop() {
      switch (this.currentTab.index) {
        case 0:
          document.querySelector(".main").scrollTop = 0;
          break;
        case 1:
          document.querySelector(".third-party").scrollTop = 0;
          break;
        case 2:
          break;
      }
    },
    changeSecondCategory(index) {
      this.secondCategoryIndex = index;
      this.search();
    },
    changeLabel(item) {
      item.isActive = !item.isActive;
      this.search();
    }
  }
};
</script>
<style lang="scss" scoped>
.creatives {
  &.white {
    background-color: #f0f2f5;
    header {
      background-color: #fff;
    }
  }

  &.dark {
    .toggle-thumnb {
      background-color: #1f2022;

      i.dark {
        background-color: #343538;
      }

      i.white {
        box-shadow: 0px 0 0 transparent;
      }
    }

    .to-top {
      background: url(../assets/images/to-top-dark.png) no-repeat center center;
    }

    header {
      .logo {
        background: url(../assets/images/dark-index-logo.png) no-repeat center
          center;
      }

      .tab-list {
        .tab-item {
          color: #c0c4cc;

          &.active:after {
            background: linear-gradient(
              82deg,
              rgba(25, 131, 249, 1) 0%,
              rgba(112, 48, 255, 1) 100%
            );
          }
        }
      }

      .user-info {
        a.back {
          p {
            color: #b2b4b8;
          }
        }

        .info {
          p.name {
            color: #fff;
          }
        }
      }
    }
  }

  .to-top {
    width: 70px;
    height: 70px;
    position: fixed;
    right: calc((100% - 1200px) / 2 - 80px);
    bottom: 50px;
    z-index: 10;
    background: url(../assets/images/to-top.png) no-repeat center center;
    cursor: pointer;

    &.blur {
      filter: blur(5px);
    }
  }

  .toggle-thumnb {
    height: 76px;
    width: 40px;
    height: 76px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 10px rgba(16, 72, 132, 0.1);
    opacity: 1;
    border-radius: 20px;
    position: absolute;
    right: calc((100% - 1200px) / 2);
    top: 100px;
    z-index: 9;

    &.blur {
      filter: blur(5px);
    }

    i {
      display: block;
      width: 32px;
      margin: 4px auto 0;
      height: 32px;
      background: url(../assets/images/dark-icon.png) center center no-repeat;
      cursor: pointer;
      border-radius: 50%;

      &.white {
        background: url(../assets/images/white-icon.png) center center no-repeat;
        box-shadow: 0px 3px 10px rgba(16, 72, 132, 0.1);
      }
    }
  }
  header {
    &.blur {
      filter: blur(5px);
    }
    width: 100%;
    height: 60px;
    background-color: #1f2022;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 120px;
    box-sizing: border-box;

    .logo {
      width: 150px;
      height: 30px;
      background: url(../assets/images/index-logo.png) no-repeat center center;
      cursor: pointer;
    }

    .tab-list {
      display: flex;
      justify-content: flex-start;
      align-content: center;
      height: 100%;
      position: relative;

      .tab-item {
        color: #606266;
        font-size: 16px;
        position: relative;
        height: 100%;
        line-height: 60px;
        // margin-right: 48px;
        padding: 0 24px;
        cursor: pointer;
        transition: 0.3s;
        -webkit-transition: 0.3s; /* Safari */

        &:last-child {
          margin-right: 0;
        }

        &.active span {
          position: relative;
          display: inline-block;
          // color: #409eff;

          // &:after {
          //   content: " ";
          //   width: 100%;
          //   height: 4px;
          //   position: absolute;
          //   left: 0;
          //   bottom: 0;
          //   background: linear-gradient(
          //     82deg,
          //     rgba(250, 213, 44, 1) 0%,
          //     rgba(255, 96, 41, 1) 100%
          //   );
          //   border-radius: 2px;
          // }
        }

        &:hover {
          // background: #f0f2f5;
          color: #409eff;
        }
        &:hover span:after {
          background: none !important;
        }
      }

      .tab-bottom-line-aisle {
        width: 100%;
        height: 4px;
        position: absolute;
        left: 0;
        bottom: 0;
        // background-color: #eee;

        .tab-bottom-line {
          width: 96px;
          height: 4px;
          position: absolute;
          left: 0;
          bottom: 0;
          background: linear-gradient(
            82deg,
            rgba(250, 213, 44, 1) 0%,
            rgba(255, 96, 41, 1) 100%
          );
          border-radius: 4px;
          transform: translateX(24px);
          transition: width .3s ease-in-out, transform .3s ease-in-out;
          z-index: 1;
        }
      }
    }

    .user-info {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;

      .info {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;

        .avatar {
          width: 30px;
          height: 30px;
          background-color: #a6dbff;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            max-width: 100%;
            max-height: 100%;
          }
        }

        p.name {
          margin-left: 8px;
          color: #909399;
          font-size: 16px;
        }

        i.more {
          width: 15px;
          height: 10px;
          background: url(../assets/images/more-icon.png) no-repeat;
          margin-left: 4px;
        }
      }

      a.back {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 30px;
        img {
          margin-right: 6px;
        }

        p {
          color: #909399;
        }
      }
    }
  }
}
</style>
